import './_promobar.scss';

export default () => {};
